import { type LoaderFunctionArgs } from "react-router";

import {
  DashboardConversationsDetailsDocument,
  type DashboardConversationsDetailsQuery,
  type DashboardConversationsDetailsQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

import { requireParam } from "@application/hooks/use_required_param";

export const DASHBOARD_CONVERSATIONS_DETAILS_LOADER = async (
  props: LoaderFunctionArgs,
) => {
  const { data } = await client.query<
    DashboardConversationsDetailsQuery,
    DashboardConversationsDetailsQueryVariables
  >({
    query: DashboardConversationsDetailsDocument,
    variables: { id: requireParam(props.params, "id") },
  });

  return data;
};
